import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraRenewSecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M52.0174 41.4236C54.9612 34.8235 54.7625 25.132 50.5053 19.1342C47.5505 14.9716 41.7481 11.7562 36.6725 11.2167C31.3715 10.6536 25.7284 11.0818 21.0738 13.7717C16.9838 16.1354 13.526 19.6628 11.637 24.0106C10.4166 26.8197 9.87109 29.9127 10.0256 32.9696C10.3331 39.0772 13.1791 45.3385 18.4028 48.662C24.7145 52.6773 33.2494 54.3587 40.4126 51.7456C44.8322 50.1332 49.9124 46.1415 52.0158 41.4236H52.0174Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M42.9951 19.9907C47.3469 23.468 49.7246 28.7254 48.3544 34.8863C47.6638 37.9887 46.0161 40.848 43.9663 43.2588C40.4644 47.376 36.379 49.7663 30.821 49.0134C25.8228 48.3374 20.3262 45.5126 17.8381 40.939C16.0407 37.6343 16.3465 33.1736 17.1239 29.6148C17.742 26.7837 18.8756 24.0624 20.4745 21.6407C21.9645 19.3821 24.082 17.8309 26.5623 16.7158C29.4698 15.4092 32.7967 15.5347 35.813 16.3817C38.5155 17.1408 40.9689 18.3721 42.9935 19.9907H42.9951Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M43.8658 33.327C44.2868 38.7209 40.8542 44.3062 34.3013 45.2551C23.4092 46.8314 15.7714 35.6891 23.5905 26.9857C30.2901 19.5293 43.0727 23.154 43.8658 33.327Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M32.1443 40.6755C35.6232 40.6755 38.4434 37.8701 38.4434 34.4095C38.4434 30.9489 35.6232 28.1436 32.1443 28.1436C28.6654 28.1436 25.8452 30.9489 25.8452 34.4095C25.8452 37.8701 28.6654 40.6755 32.1443 40.6755Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
